import { XCircleIcon } from "@heroicons/react/solid";

export default function Alert() {
  return (
    <div className="rounded-md bg-red-50 p-4 text-justify mt-10">
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            Потребно е сите полиња да бидат пополнети и согласнос за нарачка.
          </h3>
        </div>
      </div>
    </div>
  );
}
